import { gql } from '@apollo/client';

export const fetchInvoiceGroupQueryV2 = gql`
  query fetchInvoiceGroupV2($id: ID!) {
    invoiceGroup(id: $id) {
      id
      name
      currency
      updatePaymentMethodLink
      transactionAccountId
      transactionAccountNumber
      termPaymentStatus {
        status
      }
      shipToParty {
        id
        name
        addressLine1
        addressLine2
        city
        state
        country
        postcode
        taxId
        taxIds {
          id
          label
          taxExempt
          metadata {
            vatStatus
          }
        }
        shipToPriceEligibility
        taxLabels {
          region
          taxIdLabels {
            description
            displayName
            type
            metadata {
              type
              labels {
                default
                label
                vatStatus
              }
            }
          }
        }
        taxExempt
      }
      defaultPaymentMethod {
        id
        type
        default
        paymentIssue
        ... on CreditCard {
          card {
            expirationMonth
            expirationYear
            last4Numbers
            brand
            cardHolderName
          }
        }
        ... on PaymentOnTerms {
          totalCreditLimit
          paymentMethod
        }
      }
      transactionAccount {
        id
        displayName
        updatePaymentMethodLink
        partnerAccountId
        billToParty {
          name
          addressLine1
          addressLine2
          city
          state
          country
          postcode
          taxId
          taxIds {
            id
            label
            taxExempt
            metadata {
              vatStatus
            }
          }
          taxLabels {
            region
            taxIdLabels {
              description
              displayName
              type
              metadata {
                type
                labels {
                  default
                  label
                  vatStatus
                }
              }
            }
          }
          taxExempt
        }
        availablePaymentMethods {
          totalCount
          nodes {
            id
            paymentIssue
            type
            default
            ... on CreditCard {
              card {
                expirationMonth
                expirationYear
                last4Numbers
                brand
                cardHolderName
              }
            }
            ... on PaymentOnTerms {
              terms {
                invoiceDueDays
              }
              totalCreditLimit
              paymentMethod
            }
          }
        }
      }
      recipients
      purchaseOrder {
        number
        oneTimeUse
      }
    }
  }
`;
